"use client";

import { useState } from "react";
import { useRouter, usePathname } from 'next/navigation';
import Link from 'next/link';
import { Users, Map, Settings, Calculator, FileSpreadsheet, Code } from 'lucide-react';
import { cn } from "@/lib/utils";
import { 
  SidebarMenu, 
  SidebarMenuItem, 
  SidebarMenuButton,
  useSidebarContext 
} from "./sidebar";
import { Separator } from "./separator";
import { PasswordDialog } from "@/components/docs/PasswordDialog";

export function SidebarNav() {
  const { collapsed } = useSidebarContext();
  const pathname = usePathname();
  const [isPasswordDialogOpen, setIsPasswordDialogOpen] = useState(false);

  const mainNavItems = [
    {
      title: 'Customers',
      href: '/customers',
      icon: Users
    },
    {
      title: 'Maps',
      href: '/maps',
      icon: Map
    },
    {
      title: 'Settings',
      href: '/settings',
      icon: Settings
    },
    {
      title: 'Developer Portal',
      icon: Code,
      onClick: () => setIsPasswordDialogOpen(true)
    }
  ];

  const toolsNavItems = [
    {
      title: 'ROI Calculator',
      href: '/roi',
      icon: Calculator
    },
    {
      title: 'Consultation Calculator',
      href: '/consultation',
      icon: FileSpreadsheet
    }
  ];

  return (
    <>
      <SidebarMenu>
        {/* Main Navigation Items */}
        {mainNavItems.map((item) => (
          <SidebarMenuItem key={item.title}>
            {item.href ? (
              <Link href={item.href} passHref>
                <SidebarMenuButton
                  className={cn(
                    "hover:bg-accent hover:text-accent-foreground",
                    pathname === item.href && "bg-accent text-accent-foreground"
                  )}
                >
                  <item.icon className="h-4 w-4 flex-shrink-0" />
                  {!collapsed && <span className="ml-2">{item.title}</span>}
                </SidebarMenuButton>
              </Link>
            ) : (
              <SidebarMenuButton
                onClick={item.onClick}
                className="hover:bg-accent hover:text-accent-foreground"
              >
                <item.icon className="h-4 w-4 flex-shrink-0" />
                {!collapsed && <span className="ml-2">{item.title}</span>}
              </SidebarMenuButton>
            )}
          </SidebarMenuItem>
        ))}

        {/* Tools Section */}
        {!collapsed && (
          <div className="px-3 my-4">
            <Separator />
            <div className="text-xs text-muted-foreground mt-4 mb-2">Tools</div>
          </div>
        )}
        {collapsed && <Separator className="my-4" />}

        {/* Tools Navigation Items */}
        {toolsNavItems.map((item) => (
          <SidebarMenuItem key={item.href}>
            <Link href={item.href} passHref>
              <SidebarMenuButton
                className={cn(
                  "hover:bg-accent hover:text-accent-foreground",
                  pathname === item.href && "bg-accent text-accent-foreground"
                )}
              >
                <item.icon className="h-4 w-4 flex-shrink-0" />
                {!collapsed && <span className="ml-2">{item.title}</span>}
              </SidebarMenuButton>
            </Link>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>

      <PasswordDialog 
        open={isPasswordDialogOpen} 
        onOpenChange={setIsPasswordDialogOpen}
      />
    </>
  );
} 